(function() {
  'use strict';

  var sourceCache = window.BuddyIngredientAtlasSourceCache || new Map();
  window.BuddyIngredientAtlasSourceCache = sourceCache;

  function fetchIngredientSource(url) {
    if (!sourceCache.has(url)) {
      sourceCache.set(url, fetch(url, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function(response) {
        if (!response.ok) throw new Error('Ingredient source request failed.');
        return response.text();
      }).then(function(html) {
        var sourceDocument = new DOMParser().parseFromString(html, 'text/html');
        var sourceBrowser = sourceDocument.querySelector('[data-ingredients-browser]');

        if (!sourceBrowser) throw new Error('Ingredient source browser was not found.');
        return sourceBrowser;
      }));
    }

    return sourceCache.get(url);
  }

  function initializeSharedBrowser(browserRoot) {
    if (window.BuddyIngredientBrowser && typeof window.BuddyIngredientBrowser.initialize === 'function') {
      window.BuddyIngredientBrowser.initialize(browserRoot);
      return;
    }

    window.setTimeout(function() {
      initializeSharedBrowser(browserRoot);
    }, 25);
  }

  function hydrateAtlas(atlas) {
    if (atlas.dataset.ingredientAtlasHydrated === 'true' || atlas.dataset.ingredientAtlasLoading === 'true') return;

    var sourceUrl = atlas.dataset.sourceUrl || '/pages/ingredients';
    var browserRoot = atlas.querySelector('[data-ingredient-atlas-browser]');
    var sourceSlot = atlas.querySelector('[data-ingredient-atlas-source-slot]');
    var errorMessage = atlas.querySelector('[data-ingredient-atlas-error]');
    var expandButton = atlas.querySelector('[data-ingredient-expand]');

    if (!browserRoot || !sourceSlot) return;
    atlas.dataset.ingredientAtlasLoading = 'true';

    fetchIngredientSource(sourceUrl).then(function(sourceBrowser) {
      var sourceFilters = sourceBrowser.querySelector('.iit-tabs-title-container');
      var sourceGrid = sourceBrowser.querySelector('.iit-ingredients');
      var sourceDialog = sourceBrowser.querySelector('[data-ingredient-dialog]');

      if (!sourceFilters || !sourceGrid || !sourceDialog) {
        throw new Error('Ingredient source is incomplete.');
      }

      var filterClone = sourceFilters.cloneNode(true);
      var interactionHint = document.createElement('p');
      var interactionHintMobile = document.createElement('span');
      var interactionHintDesktop = document.createElement('span');
      var statusClone = document.createElement('p');
      var gridClone = sourceGrid.cloneNode(true);
      var dialogClone = sourceDialog.cloneNode(true);

      statusClone.className = 'visually-hidden';
      statusClone.dataset.ingredientStatus = '';
      statusClone.setAttribute('aria-live', 'polite');
      interactionHint.className = 'buddy-ingredient-atlas__interaction-hint';
      interactionHintMobile.className = 'buddy-ingredient-atlas__interaction-hint-mobile';
      interactionHintDesktop.className = 'buddy-ingredient-atlas__interaction-hint-desktop';
      interactionHintMobile.textContent = 'Tap any ingredient to learn more';
      interactionHintDesktop.textContent = 'Click any ingredient to learn more';
      interactionHint.append(interactionHintMobile, interactionHintDesktop);
      dialogClone.hidden = true;
      dialogClone.classList.remove('open', 'active');

      sourceSlot.replaceChildren(filterClone, interactionHint, statusClone, gridClone, dialogClone);
      sourceSlot.setAttribute('aria-busy', 'false');
      browserRoot.setAttribute('data-ingredients-browser', '');
      expandButton && expandButton.setAttribute('aria-controls', gridClone.id);

      atlas.dataset.ingredientAtlasHydrated = 'true';
      delete atlas.dataset.ingredientAtlasLoading;
      initializeSharedBrowser(browserRoot);
    }).catch(function() {
      sourceSlot.setAttribute('aria-busy', 'false');
      sourceSlot.hidden = true;
      if (errorMessage) errorMessage.hidden = false;
      delete atlas.dataset.ingredientAtlasLoading;
    });
  }

  function observeAtlas(atlas) {
    if (!('IntersectionObserver' in window)) {
      hydrateAtlas(atlas);
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      if (!entries.some(function(entry) { return entry.isIntersecting; })) return;
      observer.disconnect();
      hydrateAtlas(atlas);
    }, { rootMargin: '900px 0px' });

    observer.observe(atlas);
  }

  function initializeAtlases(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-ingredient-atlas]').forEach(observeAtlas);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initializeAtlases(document);
    }, { once: true });
  } else {
    initializeAtlases(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    initializeAtlases(event.target);
  });
})();
